import { api } from "./api";

export const GetUser = async (
  userroleid: number,
  fullname: string,
  mallid: number,
  number: number,
  page: number,
) => {
  try {
    const url = `/user/v1/getuser?userroleid=${userroleid}&fullname=${encodeURIComponent(fullname)}&mallid=${mallid}&number=${number}&page=${page}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const GetRole = async () => {
  try {
    const url = `/user/v1/getrole`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const GetUserRole = async () => {
  try {
    const url = `/user/v1/getuserrole`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};